<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout
    fluid
    column
    class="pa-0 ma-0 invoices"
    align-center
    justify-content
  >
    <page-title title="Payment History"></page-title>
    <v-flex class="invoice-table">
      <v-data-table
        :headers="headers"
        :items="list"
        class="lg-table no-pagination"
        no-data-text=""
        hide-actions
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.date }}</td>
            <td>{{ props.item.plan }}</td>
            <td class="amount">
              {{ props.item.currency }}{{ props.item.amount }}
            </td>
            <td class="download-invoice">
              <a target="_blank" :href="props.item.link"> Download </a>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          <div class="list-empty">
            Your payment history is empty
          </div>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import billingApi from '@/api/billing'
import format from 'date-fns/format'
import constants from '@/constants'

export default {
  name: 'Invoices',
  mounted: function() {
    this.getList()
  },
  data() {
    return {
      headers: [
        {
          text: 'Date',
          align: 'center',
          sortable: false,
          value: 'date'
        },
        { text: 'Plan', value: 'plan', align: 'center', sortable: false },
        { text: 'Amount', value: 'amount', align: 'center', sortable: false },
        { text: 'Invoice', value: 'link', align: 'center', sortable: false }
      ],
      invoices: [],
      loading: true,
      pagination: {
        rowsPerPage: 20
      }
    }
  },
  computed: {
    list: function() {
      return this.invoices.map(function(u) {
        return {
          id: u.id,
          date: format(new Date(u.at * 1000), constants.defaultDateFormat),
          plan: u.plan.name,
          currency: u.currency.symbol,
          amount: u.amount,
          link: `/downloads/invoices/${u.invoice_id}`
        }
      })
    }
  },
  watch: {
    $route(to, from) {}
  },
  methods: {
    getList() {
      const vm = this
      vm.loading = true
      billingApi.history().then(function(data) {
        // vm.invoices = data.data.results
        // SAMPLE DATA for Testing
        vm.invoices = data.data.results
        // vm.invoices = [
        //   {
        //     id: 'sfsdfds',
        //     at: new Date().getTime() / 1000,
        //     plan: { name: 'Growth' },
        //     currency: { id: 2, name: 'USD', symbol: '$' },
        //     amount: 100,
        //     invoice_id: 1001
        //   }
        // ]
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="stylus">
.invoices {
    width 100%
    .invoice-table {
        margin-top 50px
        width 800px
        text-align center
        .lg-table .v-datatable.v-table td, .lg-table .v-datatable.v-table th {
            color: $color-primary-light-1
        }
        .amount{
            font-weight bold
        }
        .download-invoice {
            font-weight 500
            a {
                color: $color-accent
                text-decoration none
                &:hover {
                    text-decoration underline
                }
            }

        }
    }
}
</style>
